<template>
  <div>
    <Loading v-if="!isLoaded" />
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/kakusan/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>登入會員系統</h1>
        </div>
      </header>
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-4 col-sm-6">
                <div class="card">
                  <div class="card-body">
                    <form @submit.prevent="login">
                      <div class="form-group">
                        <label for="loginMemberJPNSEQ">會員編號</label>
                        <input
                          id="loginMemberJPNSEQ"
                          v-model="loginForm.JPNSEQ"
                          type="text"
                          class="form-control"
                          maxlength="8"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label for="loginMemberPassword">密碼</label>
                        <input
                          id="loginMemberPassword"
                          v-model="loginForm.password"
                          type="password"
                          class="form-control"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <button
                          class="btn btn-primary btn-block"
                          :disabled="loginForm.submitButton.disabled"
                        >
                          {{ loginForm.submitButton.text }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </PublicLayout>
  </div>
</template>

<script>
import { getCurrentUser } from "../api/fordaysHelpers";
import Loading from "../components/Loading";
import PublicLayout from "../components/public/PublicLayout";
import db from "../api/db";
import firebase from "../api/firebase";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LoginScreen",
  components: {
    PublicLayout,
    Loading,
  },
  data() {
    return {
      isLoaded: false,
      loginForm: {
        JPNSEQ: "",
        password: "",
        submitButton: {
          text: "登入",
          disabled: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
  },
  methods: {
    ...mapActions(["finalizeSignUpUser"]),
    login() {
      const vm = this;
      const JPNSEQ = parseInt(vm.loginForm.JPNSEQ);
      vm.toggleSubmitButton(true);
      db.collection("jcustomerout")
        .where("JPNSEQ", "==", JPNSEQ)
        .get()
        .then((query) => {
          if (query.docs.length < 1) {
            alert("無此會員編號");
            vm.toggleSubmitButton(false);
            return false;
          }
          const customer = query.docs[0].data();
          const email = customer.EMAIL;
          const password = vm.loginForm.password;

          firebase
            .auth()
            .signInWithEmailAndPassword(email, password)
            .then(async () => {
              const user = await getCurrentUser(JPNSEQ);
              const authObj = {
                user,
              };
              vm.finalizeSignUpUser(authObj);
              vm.toggleSubmitButton(false);
              vm.$router.push("/member/member");
            })
            .catch((err) => {
              console.log(err);
              vm.toggleSubmitButton(false);

              const errorAlert = {
                icon: "error",
                title: "登入失敗",
              };
              if ("code" in err) {
                const code = err.code;
                if (code == "auth/wrong-password") {
                  errorAlert.text = "密碼錯誤，請輸入正確的密碼";
                  vm.$swal(errorAlert);
                }
              } else {
                errorAlert.text = "發生錯誤請重新嘗試";
                vm.$swal(errorAlert);
              }
            });
        })
        .catch((err) => {
          console.log(err);
          vm.toggleSubmitButton(false);
        });
    },
    toggleSubmitButton(disabled) {
      const vm = this;
      const submitButton = vm.loginForm.submitButton;
      if (disabled) {
        submitButton.text = "登入中請稍候";
      } else {
        submitButton.text = "登入";
      }
      submitButton.disabled = disabled;
    },
  },
  created() {
    const vm = this;
    firebase.auth().onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        let JPNSEQ = window.localStorage.getItem("FordaysJPNSEQ");
        if (JPNSEQ) {
          JPNSEQ = parseInt(JPNSEQ);
        } else {
          vm.isLoaded = true;
          return;
        }

        const user = await getCurrentUser(JPNSEQ);
        const authObj = {
          user,
        };
        vm.finalizeSignUpUser(authObj);
        vm.isLoaded = true;

        // http://localhost:8080/login?cart_id=dUZJEv3gQhr9kElq3VgD&rec_trade_id=D20211005K7WR0P
        if (vm.$route.query.cart_id && vm.$route.query.rec_trade_id) {
          const cart_id = vm.$route.query.cart_id;
          const rec_trade_id = vm.$route.query.rec_trade_id;
          vm.$router.push({
            name: "OrderFinishedScreen",
            params: {
              rec_trade_id,
              cart_id,
            },
          });
          return 0;
        }
        vm.$router.push("/member/member");
      } else {
        vm.isLoaded = true;
      }
    });
  },
};
</script>